<template>
  <!-- 企业服务-其他服务-修复 -->
  <div class="Invoice-body">
    <!-- 筛选 -->
    <el-form
      :model="screenData"
      :inline="true"
      class="screen"
      @submit.native.prevent="handelSearch"
    >
      <el-form-item label="订单ID：">
      <div class="size-search">
      <el-input maxlength="30"
      v-model="screenData.orderNumber"
      placeholder="请输入订单ID"
      ></el-input>
      </div>
      </el-form-item>
      <el-form-item label="服务类别：" class="user-Id">
      <div class="size-search">
      <el-select v-model="screenData.Category" placeholder="请选择服务类别">
      <el-option
      v-for="item in optionsCategory"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="统一社会信用代码：" class="user-Id">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.code" placeholder="请输入统一社会信用代码"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="企业类型：" class="user-Id">
      <div class="size-search">
      <el-select v-model="screenData.EnterpriseType" placeholder="请选择企业类型">
      <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="企业名称：" class="user-Id">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.input" placeholder="请输入企业名称"></el-input>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：" class="user-Id">
      <el-date-picker
      v-model="screenData.value"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="screenData.value = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
    <!--  -->
    <div class="table-top-Controls">
      <div class="RemainingLocation">
        <el-button type="primary" class="action-btn firm-clickable" @click="handelUp">修复多家</el-button>
        <el-button type="primary" class="action-btn firm-clickable" @click="handelAndLeProcess">修复一家</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="Table">
      <Table
        :tableData="tableData"
        :pagingObj="pagingObj"
        @handelDetails="handelDetails"
        @handelAndLeProcess="handelAndLeProcess"
        @handelEvaluation="handelEvaluation"
        @Refresh="Refresh"
      ></Table>
    </div>
    <!-- 底部分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <!-- 办理 -->
    <HandlePro
      :options1="options1"
      :enterprise="enterprise"
      :VisibleHandlePro="VisibleHandlePro"
      :ApplicationArr="ApplicationArr"
      @handleCloseHandlePro="VisibleHandlePro = false"
      @handleSuccess="handleSuccess"
    ></HandlePro>
    <!-- 上传 -->
    <UpEstablishment
      :VisibleUp="VisibleUp"
      :enterprise="enterprise"
      @handleCloseUp="VisibleUp = false"
      @handleSuccess="handleSuccess"
    ></UpEstablishment>
    <!-- 详情/退款 -->
    <ReOfDe
      :VisibleDeRe="VisibleDeRe"
      :DeRe="DeRe"
      :row="row"
      :createTime="createTime"
      @handleCloseDeRe="VisibleDeRe = false"
      @handleConfirmDeRe="handleConfirmDeRe"
    ></ReOfDe>
    <!-- 服务评价弹窗 -->
    <EvaluationDialog
      :VisibleEvaluation="VisibleEvaluation"
      :orderNumber="orderNumber"
      :handleTypeName="handleTypeName"
      :businessTypeName="businessTypeName"
      :evaluatedName="evaluatedName"
      @handleCloseEvaluation="handleCloseEvaluation"
      @handleSuccess="handleEvaluationSuccess"
    ></EvaluationDialog>
  </div>
</template>

<script>
import {
  listCreditRepair, //信用修复列表
  getCreditRepairInfo, //详情
  companySelectCustomers, //查询客户列表(客户下拉选择)
} from "../../../../../../assets/api/Agency/Enterprise";
import * as API from "@/assets/api/Agency/Enterprise.js";
import HandlePro from "./components/Repair/HandlePro.vue";
import ReOfDe from "./components/Repair/NewDetails.vue";
import UpEstablishment from "./components/Repair/UpEstablishment.vue";
import Table from "./components/Repair/Table.vue";
import EvaluationDialog from "../../components/EvaluationDialog.vue"; //服务评价弹框
// 引入分页组件
import paging from "../../../../../../components/paging.vue";
export default {
  data() {
    return {
      screenData: {
        value: null, // 时间
        Category: "", //服务类别
        EnterpriseType: "", //企业类型
        input: "", //企业名称
        code: "", //信用代码
        orderNumber: "",
      },
      optionsCategory: [
        { value: 0, label: "司法案件记录消除" },
        { value: 1, label: "行政处罚记录消除" },
        { value: 2, label: "其他记录消除" },
      ], //服务类别
      options: [
        { value: 0, label: "有限公司" },
        { value: 1, label: "个体户" },
        { value: 2, label: "子公司" },
        { value: 3, label: "分公司" },
        { value: 4, label: "其他" },
      ], //企业类型
      tableData: [],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      VisibleUp: false, //注销上传
      VisibleHandlePro: false, //办理
      DeRe: 0, // 0查看  1退款
      Distinguish: 0, //区分什么服务 0注销企业 1注销-银行开户  2注销开户-其他开户
      VisibleDeRe: false, //查看/退款
      VisibleEvaluation: false, //服务评价弹窗
      evaluatedName: "", // 被评价人
      orderNumber: "", //订单号
      handleTypeName: "", //服务类型
      businessTypeName: "", //服务类别
      options1: [], //平台企业的客户
      enterprise: {}, //平台企业的信息
      row: {}, //详情信息
      createTime: "", //订单时间
      ApplicationArr: [
        {
          id: 0,
          name: "司法案件记录清除",
          ShowHide: false, //后台控制是否显示

          code: ["11020601", "22020601"],
        },
        {
          id: 1,
          name: "行政处罚记录清除",
          ShowHide: false, //后台控制是否显示

          code: ["11020602", "22020602"],
        },
        {
          id: 2,
          name: "其它记录清除",
          ShowHide: false, //后台控制是否显示

          code: ["11020603", "22020603"],
        },
      ], //服务类别
    };
  },
  watch: {},
  components: {
    paging,
    Table,
    HandlePro, //办理
    UpEstablishment, //上传
    ReOfDe,
    EvaluationDialog, //服务评价弹框
  },
  created() {
    this.$tool
      .CompanyPageMenu("110206")
      .then((res) => {
        // ====================== 统一规范重写 ======================
        // 1. 构建code映射表
        const codeStatusMap = Object.fromEntries(
          res.map((item) => [item.code, item.onOrOff])
        );

        // 2. ApplicationArr 支持数组code，任意一个匹配就显示
        this.ApplicationArr.forEach((item) => {
          item.ShowHide = item.code.some(
            (code) => codeStatusMap[code] === true
          );
        });
        // ==========================================================
      });

    this.listCreditRepair();
    this.companySelectCustomers();
  },

  destroyed() {},
  methods: {
    Refresh() {
      this.listCreditRepair();
    },
    //付款成功
    handleSuccess() {
      this.VisibleUp = false;
      this.VisibleHandlePro = false;
      this.listCreditRepair();
    },
    //重置
    handelReset() {
      this.pagingObj.currentPage = 1;
      this.screenData = {
        value: null, // 时间
        Category: "", //服务类别
        EnterpriseType: "", //企业类型
        input: "", //企业名称
        code: "", //信用代码
        orderNumber: "",
      };
      this.listCreditRepair();
    },
    //搜索
    handelSearch() {
      this.pagingObj.currentPage = 1;
      this.listCreditRepair();
    },
    //查询客户列表(客户下拉选择)
    companySelectCustomers() {
      if (!this.$checkActionIpu()) return;
      API.companySelectCustomers().then((res) => {
        this.enterprise = res.data.self;
        var arr = res.data.customers;
        arr.unshift(res.data.self);
        this.options1 = arr;
      });
    },
    // 列表
    listCreditRepair() {
      // 处理时间
      var time;
      var timeEnd;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          itemType: this.screenData.Category, //服务类型
          orderCompanyType: this.screenData.EnterpriseType, //企业类型
          orderCompanyName: this.screenData.input, //企业名称
          orderCreditCode: this.screenData.code, //统一代码

          startTime: time,
          endTime: timeEnd,
          orderNumber: this.screenData.orderNumber,
        },
      };
      API.listCreditRepair(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 列表退款弹窗确认
    handleConfirmDeRe(textarea) {
      this.$tool
        .Refund(
          "/global/proxy/creditRepairRequestRefund",
          this.row.orderNumber,
          textarea
        )
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.listCreditRepair();
          }
        });
      this.VisibleDeRe = false;
    },
    // 列表点击详情/退款
    handelDetails(num, row) {
      this.createTime = row.createTime;
      var data = {
        data: {
          recordId: row.id,
        },
      };
      API.getCreditRepairInfo(data).then((res) => {
        this.row = res.data;
      });

      this.DeRe = num;
      this.VisibleDeRe = true;
    },
    // 上传设立确定
    handleConfirmUp() {
      this.VisibleUp = false;
    },
    // 上传设立
    handelUp() {
      if (!this.$checkAction()) return;
      this.VisibleUp = true;
    },
    // 办理弹窗确认
    handleVHandlePro() {
      this.VisibleHandlePro = false;
    },
    // 办理
    handelAndLeProcess(num, row) {
      if (!this.$checkAction()) return;
      // 0办理  1重新提交
      this.VisibleHandlePro = true;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.listCreditRepair();
    },
    // 服务评价
    handelEvaluation(row) {
      if (!this.$checkAction()) return;
      this.orderNumber = row.orderNumber;
      this.handleTypeName = "企业信用修复"; // 信用修复服务的服务类型固定为"信用修复"
      this.businessTypeName = row.itemTypeName;
      this.evaluatedName = (row.evaluatedName || row.beEvaluatedName || row.handlerName || row.staffName || "");
      this.VisibleEvaluation = true;
    },
    // 关闭服务评价弹框
    handleCloseEvaluation() {
      this.VisibleEvaluation = false;
    },
    // 服务评价成功
    handleEvaluationSuccess() {
      this.listCreditRepair();
    },
  },
};
</script>

<style scoped lang="less">
.Invoice-body {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  // 筛选
  .screen {
    margin-top: 10px;
    margin-bottom: 0;
    position: relative;
  }
// 表上方的操作项
  .table-top-Controls {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    align-items: center;
    .action-btn {
      width: 100px;
      height: 35px;
      background: #409eff !important;
      border-color: #409eff !important;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff !important;
      border: none;
      font-family: inherit;
      padding: 0 !important;
      line-height: 1 !important;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .RemainingLocation {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      align-items: center;
      .action-btn {
        margin-left: 20px;
      }
    }
  }
  //   表格
  .Table {
    min-height: 450px;
    margin-top: 30px;
    // border: 1px solid gold;
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
